import { useUnread } from "../../../fetch/fetch.chat.ts";

const ChatUnread = () => {
  const { chat, isLoading, isError } = useUnread(0);
  if (isLoading) return null;
  if (isError) return <span className="badge badge-xs badge-warning">E</span>;
  if (chat === 0) return null;
  return <span className="badge badge-xs badge-info">{chat}</span>;
};
export default ChatUnread;
